// SQ考试接口常数
export default {
  SQ_QUIZ_INFO: '/api/exam/quiz/info',                // 首页详情

  SQ_QUIZ_QUESTION: '/api/exam/quiz/questionInfo',    // 题目详情

  SQ_QUIZ_ANSWER: '/api/exam/quiz/answerRight',       // 是否回答正确

  SQ_QUIZ_SAVE: '/api/exam/quiz/saveAnswer',          // 保存答案

  SQ_QUIZ_STATE: '/api/exam/quiz/setJoinState',        // 设置准备状态

  BATTLE_LIST: '/api/test/battle/list',        // 对战列表/api/battle/roomList

  BATTLE_ROOMLIST: '/api/test/battle/roomList',        // 对战列表

  BATTLE_ENTERROOM: '/api/test/battle/enterRoom', // 加入房间

  BATTLE_LEAVEROOM: '/api/test/battle/leaveRoom',       // 退出房间

  BATTLE_STARTGAME: '/api/test/battle/startGame',      // 退出房间

  BATTLE_GETSIG: '/api/test/battle/getSig',

  BATTLE_END: '/api/test/battle/end',   // 结束对战

  BATTLE_SCRAMBLE: '/api/test/battle/scramble',  // 抢答

  BATTLE_ANSWER: '/api/test/battle/answer', // 答题

  BATTLE_ADDITIONALANSWER: '/api/test/battle/additionalAnswer', // bonus 答题

  BATTLE_GETROOMSCHEDULE: '/api/test/battle/getRoomSchedule',

  BATTLE_GETRESULT: '/api/test/battle/getResult', // 获取对战结果

  BATTLE_LOSTQUESTION: '/api/test/battle/lostQuestion', // 题目流失

  NAQT_RETRY_BATTLE: '/api/test/battle/retryBattle',                   // 重新开始对战

  SQ_EXAM_MEMBER: '/api/test/superQuiz/exam/members', // sq成员查询

  SQ_EXAM_ENTER_CHECK: '/api/test/superQuiz/enter/check', // sq进入查询

  SQ_EXAM_STATE_CHANGE: '/api/test/superQuiz/member/state/change', // sq更新准备状态

  SQ_EXAM_ENTER: '/api/test/superQuiz/exam/enter', // 查询考试密钥

  SQ_EXAM_QUESTION_SUBMIT: '/api/test/superQuiz/exam/question/submit', // 提交答案

  SQ_EXAM_SQ_INFO: '/api/test/superQuiz/info' // SQ 详情
}



// WEBPACK FOOTER //
// ./src/assets/api/constant/super-quiz.js